const BankStatement = () => import(/* webpackChunkName: "bankStatement" */ './BankStatement.vue')

const index = {
  path: 'bank/statements',
  name: 'Bank Statement',
  component: BankStatement,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  index
}
